"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALLEY_BANK_ARCHIVE_THRESHOLD_DAYS = exports.VALLEY_BANK_PIPELINE_STATUSES = exports.VALLEY_BANK_PIPELINE_IN_PROGRESS_STATUS = exports.VALLEY_BANK_PIPELINE_FAILURE_STATUS = exports.VALLEY_BANK_PIPELINE_SUCCESS_STATUS = exports.NEAR_MARGIN_STATUS_THRESHOLD = exports.VALLEY_BANK_RECEIVABLE_RESPONSE_TAPE_CALCULATION_QUEUE = exports.DEPOSIT_ACCOUNT_CODE = exports.LOAN_ACCOUNT_CODE = exports.OPICS_CODE = exports.CIBAR_CODE = exports.IBS_CODE = exports.VALLEY_BANK_PRIVATE_BANKING_COST_CENTER_SET = exports.VALLEY_BANK_PRIVATE_BANKING_COST_CENTERS = exports.VALLEY_BANK_BORROWERS_SECURITIES_LOAN_PRODUCT_SLUG = exports.VALLEY_BANK_BORROWERS_DEPOSITS_LOAN_PRODUCT_SLUG = exports.VALLEY_BANK_BORROWERS_VALLEY_BANK_1_CREDIT_FACILITY_SLUG = exports.VALLEY_BANK_BORROWERS_ORG_SLUG = void 0;
exports.VALLEY_BANK_BORROWERS_ORG_SLUG = 'valleyBankBorrowers';
exports.VALLEY_BANK_BORROWERS_VALLEY_BANK_1_CREDIT_FACILITY_SLUG = 'valleyBankBorrowersValleyBank1';
exports.VALLEY_BANK_BORROWERS_DEPOSITS_LOAN_PRODUCT_SLUG = 'valleyBankBorrowersDeposits';
exports.VALLEY_BANK_BORROWERS_SECURITIES_LOAN_PRODUCT_SLUG = 'valleyBankBorrowersSecurities';
// private banking cost centers
// we aren't provided this via any file at the moment.
exports.VALLEY_BANK_PRIVATE_BANKING_COST_CENTERS = [
    '10',
    '11',
    '20',
    '21',
    '31',
    '40',
    '42',
    '50',
    '53',
    '702',
    '703',
    '705',
    '710',
    '715',
    '720',
    '725',
    '741',
    '745',
    '770',
    '771',
    '772',
    '774',
    '775',
    '776',
    '778',
    '780',
    '790',
    '794',
    '796',
    '797',
    '1970',
    '1975',
    '2002',
    '2010',
    '2015',
    '2055',
    '2088',
    '2101',
    '2105',
    '2501',
    '2775',
    '2780',
    '2782',
    '2790',
    '2795',
    '2798',
    '5002',
    '5007',
    '5008',
    '5088',
    '5508',
    '5512',
    '5810',
    '5818',
    '7001',
    '7005',
    '7007',
    '7010',
    '7012',
    '7015',
    '7020',
    '7025',
    '7030',
    '7032',
    '7035',
    '7040',
    '7045',
    '7070',
    '7075',
    '7077',
    '7400',
    '7500',
    '8900',
    '9910',
];
exports.VALLEY_BANK_PRIVATE_BANKING_COST_CENTER_SET = new Set(exports.VALLEY_BANK_PRIVATE_BANKING_COST_CENTERS);
exports.IBS_CODE = '14';
exports.CIBAR_CODE = '21';
exports.OPICS_CODE = '22';
exports.LOAN_ACCOUNT_CODE = 'LN';
exports.DEPOSIT_ACCOUNT_CODE = 'DP';
exports.VALLEY_BANK_RECEIVABLE_RESPONSE_TAPE_CALCULATION_QUEUE = 'valley_bank_rrt_calculation.fifo';
exports.NEAR_MARGIN_STATUS_THRESHOLD = 0.1;
exports.VALLEY_BANK_PIPELINE_SUCCESS_STATUS = 'success';
exports.VALLEY_BANK_PIPELINE_FAILURE_STATUS = 'failure';
exports.VALLEY_BANK_PIPELINE_IN_PROGRESS_STATUS = 'in-progress';
exports.VALLEY_BANK_PIPELINE_STATUSES = [
    exports.VALLEY_BANK_PIPELINE_FAILURE_STATUS,
    exports.VALLEY_BANK_PIPELINE_SUCCESS_STATUS,
    exports.VALLEY_BANK_PIPELINE_IN_PROGRESS_STATUS,
];
exports.VALLEY_BANK_ARCHIVE_THRESHOLD_DAYS = 14;
//# sourceMappingURL=consts.js.map